
import { Component, Prop, Vue ,Model ,Watch } from "vue-property-decorator";

@Component({
    name: 'step-component',
})
export default class StepComponent extends Vue {
  @Prop() show!: boolean;
  @Prop() private fileType!: any;
  @Prop() private currentUrl!: any;
  private IsShow = false;
  @Watch('show',{immediate:true}) 
  private changeshow (val:boolean){
    // console.log(val)
    this.IsShow = val
  }




  private created () {
    // this.$nextTick(()=>{
    //   const body = document.querySelector('body')
    //   body.appendChild(this.$el)
    // })
  }
  private close(){
    this.IsShow = false
    this.$emit('close')
  }
}
